import React from 'react';
import AssetPreviewComponent from '../components/AssetPreview';
import { withAssetSelector } from '../../Uploader';

const AssetWrappedPreview = withAssetSelector(AssetPreviewComponent);

function AssetPreview(props) {
  const { assetId, asset, ...otherProps } = props;

  if (assetId) {
    return <AssetWrappedPreview assetId={assetId} {...otherProps} />;
  }

  return <AssetPreviewComponent asset={asset} {...otherProps} />;
}

export default AssetPreview;